module.exports = __webpack_public_path__ + "static/media/Header_kids.662676f7.jpg";